import { useLocation } from 'react-router-dom';
import { routes } from '../../../core/routes';
import ActiveUser from '../../Widgets/ActiveUser/ActiveUser';
import './DashboardHeader.scss';

export default function DashboardHeader() {
    const location = useLocation();
    const pageTitle = () => {
        const currentPage = Object.values(routes).flatMap((route: any) => route).find((route: any) => route.url === location.pathname);
        return currentPage.title;
    }

    return (
        <div className='DashboardHeader'>
            <div className='DashboardHeader__container-header'>
                <div className='DashboardHeader__container-header--left'>
                    <p className='DashboardHeader__container-title'>{pageTitle()}</p>
                </div>
                <div className='DashboardHeader__container-header--right'>
                    <ActiveUser />
                </div>
            </div>
        </div>
    );
}
